<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">

          <Col v-bind="grid">
            <FormItem label="搜索内容：" label-for="key">
              <Input search enter-button placeholder="请输入细项标题搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>

          <Col v-bind="grid">
            <FormItem label="筛选制度：" label-for="system_id">
              <Select v-model="filter.system_id" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="item in systemList" :value="item.system_id" :key="item.system_id">{{ item.system_name }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col v-bind="grid">
            <FormItem label="是否有效：" label-for="is_active">
              <Select v-model="filter.is_active" @on-change="select">
                <Option :value="-1">全部</Option>
                <Option :value="0">无效</Option>
                <Option :value="1">有效</Option>
              </Select>
            </FormItem>
          </Col>

          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>

        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">
          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="attachments">
          <div style="margin-bottom: 4px;" v-for="(item,index) in row.attachments" :key="index">
            <a :href="item" target="_blank">{{ '下载附件' + (index + 1) }}</a>
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.item_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="info(row.item_id)">查看</a>
          <Divider type="vertical"/>
          <a @click="del(row.item_id)">删除</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>

  </div>
</template>
<script>
import {qualitySystemItemsListApi, qualitySystemItemsDelApi} from '@/api/processing/quality/qualitySystemItems'
import {qualitySystemsAllApi} from "@/api/processing/quality/qualitySystems";

export default {
  name: 'qualitySystemItemsList',
  components: {},
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        search: '',
        system_id: 0,
        is_active: -1,
        ctime: [],
      },
      systemList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '制度名称',
          key: 'system_name',
          minWidth: 180
        },
        {
          title: '细项标题',
          key: 'title',
          minWidth: 200
        },
        {
          title: '是否有效',
          key: 'is_active_msg',
          minWidth: 150
        },
        {
          title: '制度附件',
          slot: 'attachments',
          minWidth: 150,
        },
        {
          title: '排序',
          key: 'sort_order',
          minWidth: 150
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 180
        }
      ]
    }
  },
  created () {
    this.loadQualitySystemsData()
    this.loadTableData()
  },
  activated () {
    this.loadQualitySystemsData()
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      qualitySystemItemsListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },

    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },

    // 搜索清空
    searchClear() {
      this.filter.page = 1
      this.filter.search = ''
      this.loadTableData()
    },

    // 下拉选择
    select () {
      this.filter.page = 1
      this.loadTableData()
    },

    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },

    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: () => {
          qualitySystemItemsDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.loadTableData()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 加载制度
    loadQualitySystemsData() {
      qualitySystemsAllApi().then(res => {
        //数据赋值
        this.systemList = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
